// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".commenter-image[data-v-20766195]{height:40px;width:40px;border-radius:50%;overflow:hidden;display:inline-block;vertical-align:middle}.commenter-image img[data-v-20766195]{height:100%}.reply[data-v-20766195]{display:inline;margin-left:50px;cursor:pointer;color:#007bff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
